export class CFEventForCreate {
    constructor(
        public title: string,
        public eventType: number,
        public eventId: string,
        public mention: string,
        public documentHash: string,
        public participantEmail: string,
        public status: string,
        public sendNotification: boolean
    ) {}
}
